import { getAttributeInternalPeriodID } from "./attributes";
import { TParserAttributes } from "./types";
import * as config from "./../../configuration/index";
/**
 * This function will filter the query result row based on the values of
 * - period
 * - series
 *
 * For rangecolor series instead of removing the value it will set it to "000000"
 *
 * @param newSet
 * @param row
 */
const filterResultsetRow = (newSet: TParserAttributes, row: any) => {
  Object.entries(row).forEach(([key, value]) => {
    const attr = newSet.queryResultNames[key];
    if (!attr) {
      return;
    }
    const itemPeriod = attr.namedParameters.period;
    const itemSeries = attr.namedParameters.series;
    // if period and series has been defined
    if (
      (itemPeriod && itemPeriod?.tag === "string") ||
      itemPeriod?.tag === "token"
    ) {
      const filtered =
        config.System.draftValuesHandling.getListOfDraftFilteredSeries(
          row.typename
        );
      if (
        filtered?.length > 0 &&
        (!itemSeries || filtered.includes(String(itemSeries.value)))
      ) {
        const periodIndex = getAttributeInternalPeriodID(itemPeriod.value);
        const statusValue = row[`status_${periodIndex}`];
        /**
         * Strict draft value filterin
         */
        if (config.System.draftValuesHandling.isDraftStatus(statusValue)) {
          //         if (statusValue !== '1') {
          if (key === "rangecolor") {
            row[key] = "000000";
          } else {
            delete row[key];
          }
        }
      }
    }
  });
};
export default filterResultsetRow;
